import {
  GeneralSurveyFragment,
  GeneralSurveyQuestionInput,
  GeneralSurveyUpdateInput,
  SurveyQuestionMultipleChoiceConfigurationInput,
  SurveyQuestionSingleChoiceConfigurationInput,
  SurveyQuestionSliderConfigurationInput,
  SurveyStatus,
} from '@occc/graphql';

import { GeneralSurveyConfigureFormValues } from '../components/ConfigureForm/types';
import { GeneralSurveyTargetFormValues } from '../components/TargetForm/types';
import { GeneralSurveyScheduleFormValues } from '../components/ScheduleForm/types';
import { mergeDateAndTime } from '../../../lib/date';

interface ConvertFormFieldsToUpdateInputParams {
  survey: GeneralSurveyFragment;
  chainId: string;
  configure: GeneralSurveyConfigureFormValues;
  target: GeneralSurveyTargetFormValues;
  schedule: GeneralSurveyScheduleFormValues;
}

export const convertFormFieldsToUpdateInput = ({
  survey,
  configure,
  chainId,
  target,
  schedule,
}: ConvertFormFieldsToUpdateInputParams): GeneralSurveyUpdateInput => {
  let multipleChoice: SurveyQuestionMultipleChoiceConfigurationInput | null = null;
  let singleChoice: SurveyQuestionSingleChoiceConfigurationInput | null = null;
  let slider: SurveyQuestionSliderConfigurationInput | null = null;
  if (configure.questionType === 'SurveyQuestionIntSlider') {
    slider = {
      min: configure.rangeMin,
      max: configure.rangeMax,
    };
  }

  if (configure.questionType === 'SurveyQuestionMultipleChoice') {
    multipleChoice = {
      options: configure.options,
    };
  }

  if (configure.questionType === 'SurveyQuestionSingleChoice') {
    singleChoice = {
      options: configure.options,
    };
  }

  const question: GeneralSurveyQuestionInput = {
    text: configure.question,
    configuration: {
      multipleChoice,
      singleChoice,
      slider,
    },
  };

  const publishAt = mergeDateAndTime(schedule.publishAtDate, schedule.publishAtTime);
  const expireAt = mergeDateAndTime(schedule.expireAtDate, schedule.expireAtTime);

  const partialInput: GeneralSurveyUpdateInput = {
    uuid: survey.uuid,
    chainId,
    name: configure.name,
    description: configure.description || '',
    configuration: {
      startDate: publishAt.toISOString(),
      endDate: expireAt?.toISOString() || null,
    },
  };

  if (survey.status === SurveyStatus.Draft) {
    // When SurveyStatus.Draft - everything editable
    partialInput.questions = [question];
    partialInput.audienceUuid = target.inAudience.audience.uuid;
  }
  if (survey.status === SurveyStatus.Active) {
    // When SurveyStatus.Active - question text is only thing that can be changed
    partialInput.updatedQuestions = [{ uuid: survey.questions[0].uuid, text: configure.question }];
  }
  // SurveyStatus.Archived is not editable

  return partialInput;
};
